module.exports = __webpack_public_path__ + "static/media/logo2.9f4799f1.png";